import '../../balance/invoices/invoice.scss';

import { string } from 'prop-types';
import React from 'react';
import { Badge } from 'reactstrap';

import { sapInvoiceStatusesEnum } from '../../balance/constants';
import { sapStatusColor } from '../utils';

function SapInvoiceStatusBadge({ status, ...rest }) {
  const statusFromEnum = Object.values(sapInvoiceStatusesEnum).find(
    s => s.value === status,
  );

  return (
    status && (
      <Badge
        pill
        color={sapStatusColor(status)}
        className="inv-status-badge"
        {...rest}
      >
        SAP: {statusFromEnum ? statusFromEnum.label : status}
      </Badge>
    )
  );
}

SapInvoiceStatusBadge.propTypes = {
  status: string.isRequired,
};

export default SapInvoiceStatusBadge;
